<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="hasRebateData()"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF INVESTMENT FOR TAX REBATE</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-6">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
    <div class="col-sm-6">
      <div class="rebate-summary ml-auto">
        <div class="d-flex justify-content-between">
          <strong>Total Actual Investment</strong>
          <span class="text-right ml-4">{{ getTotalActualInvestment() | currencySeparatorBD }}</span>
        </div>
        <div class="d-flex justify-content-between mt-2">
          <strong>Total Allowable Investment for Rebate</strong>
          <span class="text-right ml-4">{{ getTotalAllowableInvestment() | currencySeparatorBD }}</span>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngFor="let category of rebateCategories">
    <div
      style="page-break-inside: avoid;"
      class="row mb-5"
      *ngIf="getRows(category) as rows"
    >
      <ng-container *ngIf="rows.length > 0">
        <div class="col-12 text-center font-weight-bold mb-3">
          {{ category.title }}
        </div>

        <div class="col-12">
          <table class="table table-bordered rebate-details-table">
            <thead>
              <tr class="text-center">
                <th></th>
                <th *ngFor="let column of category.columns">{{ column.title }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of rows; let rowIndex = index">
                <td class="text-center">{{ rowIndex + 1 }}</td>
                <td
                  *ngFor="let column of category.columns"
                  [ngClass]="{ 'text-right pr-3': column.isAmount }"
                >
                  <ng-container *ngIf="column.isAmount">
                    {{ getValue(row, column.key) | currencySeparatorBD }}
                  </ng-container>
                  <ng-container *ngIf="!column.isAmount">
                    {{ getValue(row, column.key) }}
                  </ng-container>
                </td>
              </tr>
              <tr class="font-weight-bold">
                <td></td>
                <td
                  *ngFor="let column of category.columns; let columnIndex = index"
                  [ngClass]="{
                    'text-center': !column.isAmount && columnIndex === getTotalLabelColumnIndex(category.columns),
                    'text-right pr-3': column.isAmount
                  }"
                >
                  <ng-container
                    *ngIf="!column.isAmount && columnIndex === getTotalLabelColumnIndex(category.columns)"
                  >
                    Total
                  </ng-container>
                  <ng-container *ngIf="column.isAmount">
                    {{ getColumnTotal(rows, column) | currencySeparatorBD }}
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
